import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "pt-2"
};
const _hoisted_2 = {
  class: "border-b-2 border-gray-300 mb-4"
};
const _hoisted_3 = {
  class: "space-y-3"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "flex flex-row w-full gap-3"
};
const _hoisted_6 = {
  key: 0,
  class: "flex-1"
};
const _hoisted_7 = {
  class: "w-28"
};
const _hoisted_8 = {
  key: 1,
  class: "w-32"
};
const _hoisted_9 = {
  class: "flex items-center gap-1 ml-4"
};
const _hoisted_10 = {
  key: 2,
  class: "border rounded-lg p-4 bg-white-50"
};
const _hoisted_11 = {
  class: "flex items-end gap-4"
};
const _hoisted_12 = {
  class: "w-36"
};
const _hoisted_13 = {
  class: "w-36"
};
const _hoisted_14 = {
  class: "flex items-end gap-4 mb-5"
};
const _hoisted_15 = {
  class: "w-24"
};
const _hoisted_16 = {
  key: 3,
  class: "border rounded-lg p-4 bg-white-50"
};
const _hoisted_17 = {
  class: "flex items-end gap-4 mb-5"
};
const _hoisted_18 = {
  class: "flex items-center gap-2 mb-8"
};
const _hoisted_19 = {
  class: "w-40"
};
const _hoisted_20 = {
  class: "w-full"
};
const _hoisted_21 = {
  class: "flex flex-wrap items-center gap-4"
};
const _hoisted_22 = {
  class: "flex flex-row w-full gap-3"
};
const _hoisted_23 = {
  class: "flex-1"
};
const _hoisted_24 = {
  key: 0,
  class: "flex-1"
};
const _hoisted_25 = {
  key: 4,
  class: "flex flex-row w-full gap-3"
};
const _hoisted_26 = {
  class: "w-1/3"
};
const _hoisted_27 = {
  key: 0,
  class: "w-1/3"
};
const _hoisted_28 = {
  key: 5
};
const _hoisted_29 = {
  key: 6,
  class: "mt-2"
};
import { ref, computed, onMounted, reactive, nextTick, watch } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useChargesStore } from '@/services/UserService/useChargesStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useCompanyBillingStore } from '@/modules/settings/integrations/QBO/companyBillingStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import useChargeValidation from '@/composables/useChargeValidation';
import useChargePreparer from '@/composables/useChargePreparer';
import EventTracker from '@/services/eventTracker';
import { useFixedFeeFormState } from '@/modules/fixedfees/composables/useFixedFeeFormState';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import AlertBar from '@/components/AlertBar.vue';
import SkeletonRenderer from '@/components/SkeletonRenderer.vue';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import FixedFeeTimeEntriesTab from '@/modules/matters/components/FixedFeeTimeEntriesTab.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTabs from '@/components/LlTabs.vue';
import CodePicker from '@/components/CodePicker.vue';
import QuickbookProductService from '@/components/QuickbookProductService.vue';
import RevenueAllocationTab from '@/modules/matters/components/RevenueAllocationTab.vue';
import RevenueAllocationTabV2 from '@/modules/matters/components/RevenueAllocationTabV2.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useRevenueAllocationStore } from '@/stores/useRevenueAllocationStore';
import RouteService from '@/services/RouteService';
import useClientMatterStore from '@/services/useClientMatterStore';
import { storeToRefs } from 'pinia';
import { isAmountEqual, mapRawAllocationsToFormData, mapAllocationsToApiFormat, createAllocation } from '@/services/utils';
import { FIXED_FEE_FORM_SKELETON } from '@/modules/fixedfees/constants';
import { TrackingCategory, TrackingAction } from '@/constants/trackingConstants';
export default {
  __name: 'CreateChargeForm',
  props: {
    state: Object,
    stateParams: Object,
    isfromVue: {
      type: Boolean,
      default: false
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    // Angular services (auto-injected from IoC container)
    rootScope: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    },
    snippetService: {
      type: Object,
      required: false
    },
    entryEditService: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: false
    },
    entryPoint: {
      type: String,
      required: false,
      default: 'fixed_fee_list',
      validator: v => ['fixed_fee_list', 'matter_page', 'entry_page', 'quick_create', 'draft_invoice', 'fixed_fee_template_settings'].includes(v)
    },
    clientMatterManager: {
      type: Object,
      required: false
    },
    // Optional callback for save and continue flow (allows parent to handle save with matter change detection)
    onSaveAndContinue: {
      type: Function,
      required: false
    }
  },
  emits: ['close', 'fixedFeeCreated', 'chargeLoaded', 'save', 'delete', 'fixedFeeSaved'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      features
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      accountsList
    } = storeToRefs(useAccountsStore());
    const {
      getMatterById
    } = useClientMatterStore();
    const emit = __emit;
    const props = __props;
    const {
      chargeId,
      fixedFeeTemplate,
      ledes,
      showAllocation,
      matterId
    } = props.stateParams;

    // Stores and composables
    const meStore = useMeStore();
    const companyStore = useCompanyStore();
    const chargesStore = useChargesStore();
    const accountsStore = useAccountsStore();
    const companyBillingStore = useCompanyBillingStore();
    const revenueAllocationStore = useRevenueAllocationStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const {
      standardCharges,
      standardChargesWithDisplay
    } = storeToRefs(useChargesStore());
    const routeService = new RouteService(props);

    // Reactive state
    const formRef = ref(null);
    const activeTab = ref('detail');
    const chargeTabs = computed(() => [{
      value: 'detail',
      label: 'Detail',
      dataCy: 'cbff-detail-tab',
      show: true
    }, {
      value: 'allocation',
      label: 'Revenue Allocation',
      dataCy: 'cbff-allocation-tab',
      show: features.value?.compensation && !fixedFeeTemplate
    }, {
      value: 'quickbooks',
      label: 'QuickBooks Mapping',
      dataCy: 'cbff-quickbooks-tab',
      show: features.value?.qboFixedFeeAndExpenseMapping && !uiState.showQuickbookMapping && chargeId
    }, {
      value: 'timeEntries',
      label: 'Time Entries',
      dataCy: 'cbff-time-entries-tab',
      show: charge.id && !fixedFeeTemplate && features.value?.centralizedFixedFeePage
    }].filter(tab => tab.show));
    const allocationValid = ref(true);

    // Tab name mapping for analytics events
    const TAB_NAME_MAP = {
      detail: 'detail',
      allocation: 'revenue_allocation',
      quickbooks: 'quickbooks',
      timeEntries: 'time_entries'
    };

    // Fee Viewed event tracking
    const trackFeeViewed = tab => {
      if (props.tracking) {
        EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE_TAB, TrackingAction.VIEWED, {
          entryPoint: props.entryPoint,
          tab: TAB_NAME_MAP[tab] || tab
        });
      }
    };

    // Fire on initial slider open (only when viewing/editing existing fee, not creating new)
    if (chargeId) {
      trackFeeViewed('detail');
    }
    const timeEntriesTabVisited = ref(false);
    const unsavedChangesConfirmRef = ref(null);
    const originalFormState = ref(null);

    // Unsaved changes dialog state
    const unsavedDialog = reactive({
      title: 'Unsaved Changes',
      message: 'You have unsaved changes to this fixed fee. If you close now, your edits will be lost.',
      confirmText: 'Discard Changes',
      toggleText: 'Keep Editing'
    });
    const uiState = reactive({
      loading: false,
      saving: false,
      deleting: false,
      showQuickbookMapping: false
    });

    // Separate ref for chargeType to ensure reactivity
    const chargeType = ref('datebased');

    // Track original fixed fee amount to detect changes
    const originalFixedFeeAmount = ref(null);

    // Use skeleton spec from constants
    const skeletonSpec = FIXED_FEE_FORM_SKELETON;
    const charge = reactive({
      id: null,
      amount: null,
      description: '',
      label: '',
      get chargeType() {
        return chargeType.value;
      },
      set chargeType(value) {
        chargeType.value = value;
      },
      completed: false,
      billed: false,
      billedState: null,
      customFlag: false,
      cm: {
        matter: {},
        client: {}
      },
      account: null,
      codes: {
        activity: {
          id: null
        },
        task: {
          id: null
        }
      },
      limit: {
        hours: null,
        rate: {
          amount: null
        }
      },
      allocation: {},
      allocationMode: revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE,
      accounting: {}
    });
    const dates = reactive({
      start: new Date(),
      end: null
    });
    const formData = reactive({
      allocations: [],
      includeDate: false,
      count: ''
    });

    // Data arrays
    const users = ref([]);
    const revenueAllocationTabRef = ref(null);
    const timeEntriesTabRef = ref(null);
    const services = ref([]);
    const recurringPeriods = [{
      id: 'day',
      label: 'Daily'
    }, {
      id: 'week',
      label: 'Weekly'
    }, {
      id: 'month',
      label: 'Monthly'
    }, {
      id: 'quarter',
      label: 'Quarterly'
    }, {
      id: 'year',
      label: 'Yearly'
    }];
    const {
      amountValidationRules,
      descriptionValidationRules,
      limitRateValidationRules
    } = useChargeValidation(charge, companySettings.value);
    const {
      prepareChargeData: prepareChargeDataForSubmission
    } = useChargePreparer();

    // Selected values
    const matterLoading = ref(false);
    const selectedStandard = ref(null);
    const selectedService = ref(null);
    const recurrence = ref(null);
    const showHourLimit = ref(false);

    // Initialize form state management for unsaved changes detection
    const {
      captureOriginalState,
      hasUnsavedChanges,
      getUnsavedChangesDialogConfig,
      resetOriginalState
    } = useFixedFeeFormState({
      charge,
      dates,
      formData,
      getRecurrence: () => recurrence.value,
      originalState: originalFormState
    });
    const cmQueryFilter = computed(() => ({
      originating: false,
      involved: false,
      reviewer: false,
      primary: false,
      status: '',
      archived: false,
      showOrphans: false
    }));

    // Lock client/matter when creating a new fixed fee from Matter → Fixed Fees
    // This occurs when matterId is provided but chargeId is not (i.e., creating new, not editing)
    const isClientMatterLocked = computed(() => {
      return !chargeId && !!matterId;
    });
    const showCodePicker = computed(() => {
      if (ledes) {
        return true;
      }
      if (charge.id && (charge.codes?.activity?.id || charge.codes?.task?.id)) {
        return true;
      }
      if (charge.matterDetail?.id && charge.matterDetail?.client?.codes?.ledes && !matterLoading.value) {
        return true;
      }
      return false;
    });

    // Methods
    const activate = async searchText => {
      uiState.loading = true;
      try {
        await Promise.all([meStore.getMe(), companyStore.loadMyCompany(true), chargesStore.loadStandardCharges(), accountsStore.listAccounts()]);
        if (features.value?.qboFixedFeeAndExpenseMapping) {
          const servicesData = await companyBillingStore.getAccountingServices();
          services.value = servicesData?.services || [];
        }
        users.value = accountsList.value.filter(hasAssignPermission);
        if (chargeId) {
          await loadExistingCharge();
        } else {
          await loadNewCharge();
        }

        // Set label from search text if provided (e.g., from EditEntry)
        if (searchText) {
          charge.label = searchText;
        }
      } catch (error) {
        handleError(error);
      } finally {
        uiState.loading = false;
      }
    };
    const loadExistingCharge = async () => {
      try {
        const chargeData = await chargesStore.getCharge(chargeId);
        const savedCodes = {
          activity: chargeData.codes?.activity && Object.keys(chargeData.codes?.activity).length > 0 ? {
            ...chargeData.codes.activity
          } : null,
          task: chargeData.codes?.task && Object.keys(chargeData.codes?.task).length > 0 ? {
            ...chargeData.codes.task
          } : null
        };
        Object.assign(charge, chargeData);
        originalFixedFeeAmount.value = chargeData.amount;

        // Map matter and client to cm structure for ClientMatterSearch component
        // Keep both structures in sync - cm for the picker, matter/client for other code
        if (chargeData.matter || chargeData.client) {
          charge.cm = {
            matter: chargeData.matter ? {
              ...chargeData.matter
            } : {},
            client: chargeData.client || chargeData.matter?.client ? {
              ...(chargeData.client || chargeData.matter?.client)
            } : {}
          };
          // Set matterDetail for validation - use matter data from charge
          charge.matterDetail = chargeData.matter || null;
        }

        // Ensure charge.limit structure exists (may be null/undefined for older charges)
        if (!charge.limit) {
          charge.limit = {
            hours: null,
            rate: {
              amount: null
            }
          };
        }

        // Set showHourLimit based on existing data
        if (chargeData.limit?.hours) {
          showHourLimit.value = true;
        }
        charge.codes = {
          activity: savedCodes.activity,
          task: savedCodes.task
        };
        if (chargeData.fixedFeeAllocationMode !== undefined && chargeData.fixedFeeAllocationMode !== null) {
          const numericMode = revenueAllocationStore.ALLOCATION_MODE_FROM_API[chargeData.fixedFeeAllocationMode] ?? revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE;
          charge.allocationMode = numericMode;
          revenueAllocationStore.setAllocationMode(numericMode);
        } else {
          charge.allocationMode = revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE;
          revenueAllocationStore.setAllocationMode(revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE);
        }
        if (chargeData.allocation?.accounts && chargeData.allocation.accounts.length > 0) {
          formData.allocations = mapRawAllocationsToFormData(chargeData.allocation.accounts, users.value, chargeData.amount, chargeData.account?.id);
        }
        await nextTick(() => {
          if (chargeData.chargeType) {
            chargeType.value = chargeData.chargeType.toLowerCase();
          }
        });
        if (chargeData.date) {
          if (chargeData.chargeType === 'completionbased' && !chargeData.completed) {
            dates.start = null;
          } else {
            dates.start = new Date(chargeData.date);
          }
        }
        if (chargeData.recurrence && !(chargeData.chargeType === 'completionbased' && !chargeData.completed)) {
          const periodValue = chargeData.recurrence.period?.toLowerCase();
          recurrence.value = recurringPeriods.find(p => p.id === periodValue);
          formData.includeDate = !!chargeData.recurrence.includeDateInDescription;
          // EndDate and Count are mutually exclusive — explicitly clear the other field
          // in every branch so stale state from a previously loaded charge can never
          // leak through and produce an ambiguous save payload with both set.
          if (chargeData.recurrence.endDate) {
            dates.end = new Date(chargeData.recurrence.endDate);
            formData.count = '';
          } else if (chargeData.recurrence.count != null) {
            dates.end = null;
            formData.count = chargeData.recurrence.count;
          } else {
            dates.end = null;
            formData.count = '';
          }
        } else {
          recurrence.value = null;
          dates.end = null;
          formData.count = '';
          formData.includeDate = false;
        }
        if (chargeData.standardChargeId && standardCharges.value.length) {
          selectedStandard.value = standardCharges.value.find(s => s.id === chargeData.standardChargeId);
        }
        if (chargeData.accounting?.service) {
          selectedService.value = chargeData.accounting.service;
        }
        emit('chargeLoaded', chargeData);

        // Capture original state for unsaved changes detection after all data is loaded
        await nextTick();
        captureOriginalState();
      } catch (error) {
        handleError('Failed to load charge data');
      }
    };
    const loadNewCharge = async () => {
      revenueAllocationStore.initializeStore();
      const companyDefaultMode = companySettings.value?.fixedFeeAllocationMode;
      if (companyDefaultMode) {
        const defaultAllocationMode = revenueAllocationStore.ALLOCATION_MODE_FROM_API[companyDefaultMode] ?? revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE;
        charge.allocationMode = defaultAllocationMode;
        revenueAllocationStore.setAllocationMode(defaultAllocationMode);
      } else {
        charge.allocationMode = revenueAllocationStore.ALLOCATION_MODES.PERCENTAGE;
      }

      // Pre-populate matter from route params (e.g., when creating from Matter → Fixed Fees)
      if (matterId && !fixedFeeTemplate) {
        try {
          matterLoading.value = true;
          const matterData = await getMatterById(matterId, true);
          charge.matterDetail = matterData;
          charge.cm.matter = matterData;
          charge.cm.client = matterData.client || {};
          emit('chargeLoaded', {
            cm: charge.cm,
            matterLabel: matterData.name || 'New Fixed Fee',
            clientLabel: matterData.client?.name || '',
            matter: matterData
          });
        } catch (error) {
          handleError('Failed to load matter details');
          emit('chargeLoaded', {
            cm: charge.cm,
            matterLabel: 'New Fixed Fee',
            clientLabel: ''
          });
        } finally {
          matterLoading.value = false;
        }
      } else {
        emit('chargeLoaded', {
          cm: charge.cm,
          matterLabel: charge.cm?.matter?.name || 'New Fixed Fee',
          clientLabel: charge.cm?.client?.name || ''
        });
      }

      // Capture original state for unsaved changes detection after new charge is initialized
      await nextTick();
      captureOriginalState();
    };
    const hasAssignPermission = account => {
      if (!companySettings.value?.permissions) {
        return true;
      }
      const permission = companySettings.value.permissions.roles[account.role];
      if (permission?.charges?.assignToCharge === undefined) {
        return true;
      }
      return permission.charges.assignToCharge;
    };
    const matterChanged = async () => {
      if (!charge.cm.matter?.id) {
        charge.matterDetail = null;
        emit('chargeLoaded', {
          id: charge.id,
          // Preserve charge ID for updates
          clientLabel: '',
          matterLabel: '',
          matter: null
        });
        return;
      }
      try {
        matterLoading.value = true;
        charge.matterDetail = await getMatterById(charge.cm.matter.id, true);

        // Emit charge loaded event to update parent header
        emit('chargeLoaded', {
          id: charge.id,
          // Preserve charge ID for updates
          clientLabel: charge.cm.client?.name || '',
          matterLabel: charge.cm.matter?.name || '',
          matter: charge.matterDetail
        });
      } catch (error) {
        handleError('Failed to load matter details');
        charge.matterDetail = null;
      } finally {
        matterLoading.value = false;
      }
    };
    const applyBasicChargeFields = standard => {
      charge.amount = standard.amount;
      charge.description = standard.description;
      charge.label = standard.label;
    };
    const applyChargeLimit = standard => {
      // Reset limit if standard doesn't have hours but charge does
      if (!standard?.limit?.hours && charge?.limit?.hours) {
        charge.limit = {
          hours: null,
          rate: {
            amount: null
          }
        };
        return;
      }

      // Apply standard limit configuration
      if (standard.limit?.hours) {
        charge.limit.hours = standard.limit.hours;
      }
      if (standard.limit?.rate) {
        charge.limit.rate = standard.limit.rate;
      }
    };
    const applyCustomFlag = standard => {
      if (companySettings.value?.labels?.customFlag) {
        charge.customFlag = standard.customFlag || false;
      }
    };
    const applyLedesCodes = standard => {
      charge.codes = showCodePicker.value && standard?.codes ? standard.codes : {};
    };
    const applyAccountAssignment = standard => {
      if (standard?.account) {
        charge.account = standard.account;
      } else if (charge.account) {
        // Clear existing account if standard doesn't have one
        charge.account = null;
      }
    };
    const applyQuickBooksMapping = standard => {
      if (features.value?.qboFixedFeeAndExpenseMapping) {
        charge.accounting = standard?.accounting || {};
      }
    };
    const applyAllocationFromStandard = standard => {
      // If the standard has allocation data, apply it
      if (standard?.allocation?.accounts && users.value.length > 0) {
        formData.allocations = mapRawAllocationsToFormData(standard.allocation.accounts, users.value, charge.amount, charge.account?.id);
      }
    };
    const standardChanged = () => {
      if (!selectedStandard.value) return;
      const standard = standardCharges.value.find(s => s.id === selectedStandard.value.id);
      if (!standard) return;
      applyBasicChargeFields(standard);
      applyChargeLimit(standard);
      applyCustomFlag(standard);
      applyLedesCodes(standard);
      applyAccountAssignment(standard);
      applyQuickBooksMapping(standard);
      applyAllocationFromStandard(standard);
    };
    const onAllocationValidationChanged = isValid => {
      allocationValid.value = isValid;
    };
    const productServiceChanged = service => {
      selectedService.value = service;
    };
    const validateChargeData = () => {
      const errors = useChargeValidation(charge, companySettings.value).validateChargeData();

      // Templates don't require a matter selection
      if (fixedFeeTemplate) {
        return errors.filter(e => e !== 'Please select a matter');
      }
      return errors;
    };
    const prepareChargeData = () => {
      // Set allocation mode from revenue allocation store only if feature is enabled
      if (features.value?.fixedFeeAllocation) {
        charge.allocationMode = revenueAllocationStore.allocationMode;
      }

      // Skip allocation validation and processing for fixed fee templates
      if (fixedFeeTemplate) {
        // Clear all allocation data for templates
        charge.allocation = {};
        formData.allocations = [];
      } else {
        // Validate allocations before preparing charge data (only for regular charges)
        if (formData.allocations && formData.allocations.length > 0) {
          const total = formData.allocations.reduce((sum, a) => sum + (Number(a.amount) || 0), 0);
          const chargeAmount = Number(charge.amount) || 0;
          if (!isAmountEqual(total, chargeAmount)) {
            // Allow for small rounding differences
            handleError('The allocations must add up to the fixed fee amount exactly');
            return;
          }

          // Set the allocation data on the charge using utility function
          charge.allocation = mapAllocationsToApiFormat(formData.allocations);
        } else {
          // Clear allocation if no allocations are set
          charge.allocation = {};
        }
      }
      return prepareChargeDataForSubmission(charge, dates, formData, recurrence.value, selectedService.value, selectedStandard.value, features.value);
    };

    // LlDatePicker re-emits update:modelValue whenever its bound value changes
    // for any reason, including us programmatically clearing it from the Count
    // handler below — guard so that echo (val === null) doesn't wipe a Count
    // the user is actively typing.
    const handleEndDateChange = val => {
      if (val) {
        formData.count = '';
      }
    };
    const handleEnterKey = event => {
      if (event.target.tagName === 'TEXTAREA' && !event.ctrlKey && !event.metaKey) {
        return;
      }
      event.preventDefault();
      emit('save');
    };
    const handleCodeChange = event => {
      charge.codes = event;
    };
    const allocationTabInitialized = ref(false);
    const handleAllocationUpdate = newAllocations => {
      formData.allocations = newAllocations;
    };
    const prepareAllocationTab = () => {
      if (allocationTabInitialized.value && formData.allocations.length > 0) {
        if (charge.account) {
          const accountId = typeof charge.account === 'string' ? charge.account : charge.account.id;
          formData.allocations = formData.allocations.map(allocation => ({
            ...allocation,
            main: allocation.account?.id === accountId
          }));
        }
        return;
      }
      if (charge.allocation?.accounts && formData.allocations.length === 0) {
        formData.allocations = mapRawAllocationsToFormData(charge.allocation.accounts, users.value, charge.amount, charge.account?.id);
        allocationTabInitialized.value = true;
        return;
      }
      if (charge.account && charge.amount) {
        const accountId = typeof charge.account === 'string' ? charge.account : charge.account.id;
        if (formData.allocations.length === 0) {
          const user = users.value.find(u => u.id === accountId);
          if (user) {
            const newAlloc = createAllocation(user, charge.amount, charge.amount, true);
            formData.allocations.push(newAlloc);
            allocationTabInitialized.value = true;
          }
        } else {
          const hasOnlyOneFullAllocation = formData.allocations.length === 1 && formData.allocations[0].amount === charge.amount;
          if (hasOnlyOneFullAllocation && !allocationTabInitialized.value) {
            const user = users.value.find(u => u.id === accountId);
            if (user) {
              formData.allocations = [createAllocation(user, charge.amount, charge.amount, true)];
              allocationTabInitialized.value = true;
            }
          } else {
            formData.allocations = formData.allocations.map(allocation => ({
              ...allocation,
              main: allocation.account?.id === accountId
            }));
            allocationTabInitialized.value = true;
          }
        }
      } else if (!charge.account && formData.allocations.length > 0) {
        formData.allocations = formData.allocations.map(allocation => ({
          ...allocation,
          main: false
        }));
      }
    };
    onMounted(async () => {
      await activate();
      if (formRef.value) {
        formRef.value?.focus?.();
      }
      if (showAllocation) {
        activeTab.value = 'allocation';
        prepareAllocationTab();
      }
    });

    // Watch showHourLimit to clear values when unchecked
    watch(showHourLimit, newVal => {
      if (!newVal) {
        charge.limit.hours = null;
        if (charge.limit.rate) {
          charge.limit.rate.amount = null;
        }
      }
    });

    // Handle charge type changes - mirrors original Angular changeType() behavior
    watch(chargeType, newVal => {
      if (newVal === 'completionbased' && !charge.completed) {
        dates.start = null;
        recurrence.value = null;
      } else if (newVal === 'datebased') {
        dates.start = new Date();
      }
    });
    watch(activeTab, async (newTab, oldTab) => {
      // Track tab switch
      trackFeeViewed(newTab);

      // Force reload time entries every time the tab becomes active
      if (newTab === 'timeEntries' && charge.id) {
        timeEntriesTabVisited.value = true;
        await nextTick();
        if (timeEntriesTabRef.value) {
          await timeEntriesTabRef.value.loadEntries(true); // Always force refresh from API
        }
      }
      if (!fixedFeeTemplate && oldTab === 'allocation' && newTab !== 'allocation' && !allocationValid.value) {
        nextTick(() => {
          activeTab.value = 'allocation';
        });
        handleError('Allocations must add up to the fixed fee amount');
        return;
      }
      if (newTab === 'allocation') {
        prepareAllocationTab();

        // Reload allocation data if returning from time entries tab OR if amount changed
        const shouldReloadAllocations = timeEntriesTabVisited.value || charge.id && originalFixedFeeAmount.value !== null && Number(charge.amount) !== Number(originalFixedFeeAmount.value);
        if (charge.id && shouldReloadAllocations) {
          const currentAmount = Number(charge.amount) || 0;
          if (currentAmount > 0) {
            await revenueAllocationStore.loadAllocationsForMode(charge.id, revenueAllocationStore.allocationMode, users.value, currentAmount);
            if (revenueAllocationStore.allocations.length > 0) {
              const rawAllocations = revenueAllocationStore.allocations.map(a => ({
                ...a,
                id: a.accountId
              }));
              formData.allocations = mapRawAllocationsToFormData(rawAllocations, users.value, currentAmount, charge.account?.id);
            }

            // Reset the flag after reload
            timeEntriesTabVisited.value = false;
          }
        }
      }
    });

    // Sync charge.amount to revenueAllocationStore whenever it changes
    watch(() => charge.amount, newAmount => {
      const amount = Number(newAmount) || 0;
      revenueAllocationStore.chargeAmount = amount;
    });

    // Public API exposed to parent components
    const getChargeData = () => charge;
    const getFormData = () => formData;
    const getDates = () => dates;
    const getRecurrence = () => recurrence.value;
    const getSelectedService = () => selectedService.value;
    const getChargeType = () => chargeType.value;
    const getUiState = () => uiState;
    const validateForm = validateChargeData;
    const prepareData = prepareChargeData;
    const getAllocationValid = () => allocationValid.value;
    const getOriginalAmount = () => originalFixedFeeAmount.value;

    /**
     * Check if form is valid for saving
     * @returns {Boolean}
     */
    const isFormValid = () => {
      const errors = validateChargeData();
      return !errors || errors.length === 0;
    };

    /**
     * Save the current charge and return success status
     * If onSaveAndContinue prop is provided, delegates to parent for matter change detection
     * Otherwise falls back to direct save (backward compatible)
     * @returns {Promise<Boolean>}
     */
    const saveAndContinue = async () => {
      if (!isFormValid()) {
        return false;
      }
      const chargeData = prepareChargeData();
      if (!chargeData) {
        return false;
      }
      try {
        // If parent provided a save handler, use it (enables matter change detection)
        if (props.onSaveAndContinue) {
          const isCreate = !charge.id;
          const success = await props.onSaveAndContinue({
            chargeData,
            chargeId: charge.id,
            originalAmount: getOriginalAmount()
          });
          if (success) {
            const label = fixedFeeTemplate ? 'Fixed fee template' : 'Fixed fee';
            handleSuccess(`${label} ${charge.id ? 'updated' : 'created'} successfully`);

            // Track Fixed Fee Created event (save-and-continue via parent handler)
            if (isCreate && props.tracking) {
              EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE, TrackingAction.CREATED, {
                entryPoint: props.entryPoint,
                isTemplate: !!fixedFeeTemplate
              });
            }
            captureOriginalState();
            emit('fixedFeeSaved');
          }
          return success;
        }

        // Fallback: direct save (backward compatible)
        if (charge.id) {
          const originalAmount = getOriginalAmount();
          const currentAmount = Number(charge.amount) || 0;
          const originalAmountValue = Number(originalAmount) || 0;
          const newFixedFeeAmount = currentAmount !== originalAmountValue ? currentAmount : null;
          await chargesStore.updateCharge(charge.id, chargeData, newFixedFeeAmount);
        } else {
          await chargesStore.createChargeWithType(chargeData, fixedFeeTemplate);

          // Track Fixed Fee Created event (direct save fallback)
          if (props.tracking) {
            EventTracker.trackEvent(props.tracking, TrackingCategory.FIXED_FEE, TrackingAction.CREATED, {
              entryPoint: props.entryPoint,
              isTemplate: !!fixedFeeTemplate
            });
          }
        }
        const label = fixedFeeTemplate ? 'Fixed fee template' : 'Fixed fee';
        handleSuccess(`${label} ${charge.id ? 'updated' : 'created'} successfully`);
        captureOriginalState();
        emit('fixedFeeSaved');
        return true;
      } catch (error) {
        handleError(error);
        return false;
      }
    };

    /**
     * Confirm whether to proceed when there are unsaved changes
     * Following the Time Entry pattern for consistent UX
     * @param {String} action - Description of the action being performed
     * @returns {Promise<Boolean>} - true if should proceed, false if should stay
     */
    const confirmDiscardChanges = async (action = 'selecting another fixed fee') => {
      // No changes - proceed immediately
      if (!hasUnsavedChanges.value) {
        return true;
      }
      const isExisting = !!charge.id;
      const isValid = isFormValid();
      const config = getUnsavedChangesDialogConfig(isExisting, isValid, action);

      // Update dialog state
      unsavedDialog.title = config.title;
      unsavedDialog.message = config.message;
      unsavedDialog.confirmText = config.confirmText;
      unsavedDialog.toggleText = config.toggleText;
      if (!unsavedChangesConfirmRef.value) {
        // If confirmation dialog is not available, use config defaults
        if (config.onConfirmAction === 'save') {
          return await saveAndContinue();
        }
        return config.proceedOnToggle;
      }
      const confirmed = await unsavedChangesConfirmRef.value.open();

      // Reset dialog to default state
      unsavedDialog.title = 'Unsaved Changes';
      unsavedDialog.message = 'You have unsaved changes to this fixed fee. If you close now, your edits will be lost.';
      unsavedDialog.confirmText = 'Discard Changes';
      unsavedDialog.toggleText = 'Keep Editing';
      if (confirmed) {
        // User clicked confirm button
        if (config.onConfirmAction === 'save') {
          const saved = await saveAndContinue();
          return saved; // Only proceed if save was successful
        } else if (config.onConfirmAction === 'stay') {
          return false; // Stay and finish editing
        }
      }

      // User clicked toggle button (Cancel/Keep Editing/Discard)
      return config.proceedOnToggle;
    };

    /**
     * Check if form has unsaved changes (exposed for parent components)
     * @returns {Boolean}
     */
    const getHasUnsavedChanges = () => hasUnsavedChanges.value;
    __expose({
      activate,
      getChargeData,
      getFormData,
      getDates,
      getRecurrence,
      getSelectedService,
      getChargeType,
      getUiState,
      validateForm,
      prepareData,
      getAllocationValid,
      getOriginalAmount,
      confirmDiscardChanges,
      getHasUnsavedChanges,
      isFormValid
    });
    return (_ctx, _cache) => {
      const _component_v_radio = _resolveComponent("v-radio");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_tooltip = _resolveComponent("v-tooltip");
      const _component_v_radio_group = _resolveComponent("v-radio-group");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_window_item = _resolveComponent("v-window-item");
      const _component_v_window = _resolveComponent("v-window");
      return _openBlock(), _createElementBlock("div", {
        class: "create-charge-form",
        tabindex: "0",
        onKeydown: _withKeys(handleEnterKey, ["enter"]),
        ref_key: "formRef",
        ref: formRef
      }, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "unsavedChangesConfirmRef",
        ref: unsavedChangesConfirmRef,
        title: unsavedDialog.title,
        message: unsavedDialog.message,
        "toggle-text": unsavedDialog.toggleText,
        "confirm-text": unsavedDialog.confirmText,
        "show-warning-icon": true,
        "data-cy": "fixed-fee-unsaved-changes-dialog"
      }, null, 8, ["title", "message", "toggle-text", "confirm-text"]), uiState.loading ? (_openBlock(), _createBlock(SkeletonRenderer, {
        key: 0,
        spec: _unref(skeletonSpec),
        "container-class": "pt-2 space-y-4 pa-4 h-screen"
      }, null, 8, ["spec"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlTabs, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        items: chargeTabs.value,
        density: "default"
      }, null, 8, ["modelValue", "items"])]), charge.billedState && charge.billedState !== 'WIP' ? (_openBlock(), _createBlock(AlertBar, {
        key: 0,
        content: charge.billedState === 'Interim' ? 'This fee is currently in a draft invoice. It can only be edited within the draft.' : 'This fee has been billed. The only editable fields are the invoice user and the allocation detail.',
        class: "mb-4"
      }, null, 8, ["content"])) : _createCommentVNode("", true), _createVNode(_component_v_window, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => activeTab.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_v_window_item, {
          value: "detail"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [!_unref(fixedFeeTemplate) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(ClientMatterSearch, {
            horizontal: false,
            emitOnAnyChange: true,
            cm: charge.cm,
            "query-filter": cmQueryFilter.value,
            onMatterChange: matterChanged,
            disabled: charge.billed || uiState.saving || isClientMatterLocked.value,
            "data-cy": "cbff-client-matter-search"
          }, null, 8, ["cm", "query-filter", "disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [!_unref(fixedFeeTemplate) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(LlSelect, {
            modelValue: selectedStandard.value,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => selectedStandard.value = $event), standardChanged],
            items: _unref(standardChargesWithDisplay),
            "item-title": "displayText",
            "item-value": "id",
            "return-object": "",
            placeholder: "Select Fixed Fee Template",
            label: "Fixed Fee Template",
            isAutocomplete: "",
            "hide-details": true,
            disabled: matterLoading.value || uiState.saving || charge.billed,
            "data-cy": "cbff-template-select",
            loading: matterLoading.value
          }, null, 8, ["modelValue", "items", "disabled", "loading"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createVNode(LlTextField, {
            modelValue: charge.amount,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => charge.amount = $event),
            modelModifiers: {
              number: true
            },
            type: "number",
            disabled: charge.billed,
            label: "Amount",
            "data-cy": "cbff-amount-field",
            rules: _unref(amountValidationRules),
            "hide-details": true
          }, null, 8, ["modelValue", "disabled", "rules"])]), !charge.billed && !_unref(fixedFeeTemplate) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(LlSelect, {
            modelValue: recurrence.value,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => recurrence.value = $event), _cache[4] || (_cache[4] = value => {
              recurrence.value = value;
              chargeType.value = 'datebased';
            })],
            items: recurringPeriods,
            placeholder: "Bill Once",
            "item-title": "label",
            "item-value": "id",
            "return-object": "",
            label: "Recurring",
            clearable: "",
            "hide-details": true,
            "data-cy": "cbff-recurring-select"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]), !_unref(fixedFeeTemplate) ? (_openBlock(), _createBlock(_component_v_radio_group, {
            key: 1,
            modelValue: chargeType.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => chargeType.value = $event),
            disabled: charge.billed,
            inline: "",
            "hide-details": "",
            class: "pt-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_radio, {
              value: "datebased",
              label: "On a specific date",
              color: "primary",
              "data-cy": "cbff-datebased-radio"
            }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_v_radio, {
              value: "completionbased",
              label: "On completion",
              color: "primary",
              "data-cy": "cbff-completion-radio"
            }), _createVNode(_component_v_tooltip, {
              location: "top"
            }, {
              activator: _withCtx(({
                props: tipProps
              }) => [_createVNode(_component_v_icon, _mergeProps(tipProps, {
                size: "16",
                class: "text-gray-400 cursor-help"
              }), {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("mdi-information-outline", -1)]))]),
                _: 1
              }, 16)]),
              default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("span", null, "Will be ready to bill when manually marked complete.", -1))]),
              _: 1
            })])]),
            _: 1
          }, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true), !_unref(fixedFeeTemplate) && chargeType.value === 'datebased' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(LlDatePicker, {
            modelValue: dates.start,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dates.start = $event),
            disabled: charge.billed,
            max: dates.end,
            "data-cy": "cbff-date-picker",
            label: recurrence.value ? 'Next Date' : 'Start Date'
          }, null, 8, ["modelValue", "disabled", "max", "label"])]), recurrence.value && !charge.billed ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_13, [_createVNode(LlDatePicker, {
            modelValue: dates.end,
            "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => dates.end = $event), handleEndDateChange],
            disabled: charge.billed,
            min: dates.start,
            label: "End Date",
            "data-cy": "cbff-end-date-picker"
          }, null, 8, ["modelValue", "disabled", "min"])]), _createElementVNode("div", _hoisted_14, [_cache[25] || (_cache[25] = _createElementVNode("span", {
            class: "text-gray-500 font-medium mb-3"
          }, "OR", -1)), _createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
            modelValue: formData.count,
            "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => formData.count = $event), _cache[9] || (_cache[9] = $event => dates.end = null)],
            type: "number",
            min: 1,
            label: "Count",
            "hide-details": true,
            "data-cy": "cbff-count-field"
          }, null, 8, ["modelValue"])])])], 64)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), !_unref(fixedFeeTemplate) && chargeType.value === 'completionbased' && charge.completed ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_v_icon, {
            color: "success",
            size: "20"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("mdi-check-circle", -1)]))]),
            _: 1
          }), _cache[27] || (_cache[27] = _createElementVNode("span", {
            class: "text-sm text-gray-600 font-medium"
          }, "Completed", -1))]), _createElementVNode("div", _hoisted_19, [_createVNode(LlDatePicker, {
            modelValue: dates.start,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => dates.start = $event),
            disabled: charge.billed,
            label: "Completion Date",
            "data-cy": "cbff-completion-date-picker"
          }, null, 8, ["modelValue", "disabled"])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createVNode(LlTextarea, {
            modelValue: charge.description,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => charge.description = $event),
            disabled: charge.billed,
            label: "Invoice Description",
            rules: _unref(descriptionValidationRules),
            "data-cy": "cbff-description",
            "hide-details": false
          }, null, 8, ["modelValue", "disabled", "rules"])]), _createElementVNode("div", _hoisted_21, [_unref(companySettings).labels?.customFlag ? (_openBlock(), _createBlock(LlCheckbox, {
            key: 0,
            modelValue: charge.customFlag,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => charge.customFlag = $event),
            label: _unref(companySettings).labels.customFlag,
            disabled: charge.billed,
            "hide-details": "",
            "data-cy": "cbff-custom-flag-checkbox"
          }, null, 8, ["modelValue", "label", "disabled"])) : _createCommentVNode("", true), recurrence.value ? (_openBlock(), _createBlock(LlCheckbox, {
            key: 1,
            modelValue: formData.includeDate,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.includeDate = $event),
            label: "Add recurring period to description",
            info: "For monthly recurring fees, the month will be appended to the description on invoices. Similarly for quarterly and yearly fees.",
            "hide-details": "",
            "data-cy": "cbff-include-date-checkbox"
          }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(LlCheckbox, {
            modelValue: showHourLimit.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showHourLimit.value = $event),
            label: "Add hour limit",
            info: "Set a maximum number of hours included in the fixed fee",
            "hide-details": "",
            "data-cy": "cbff-add-hour-limit-checkbox"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(LlTextField, {
            modelValue: charge.label,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => charge.label = $event),
            placeholder: "Optional",
            label: "Label",
            info: "A short optional description for internal use (not shown to clients)",
            "data-cy": 'cbff-label-field',
            disabled: charge.billed,
            "hide-details": true
          }, null, 8, ["modelValue", "disabled"])]), users.value && users.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(LlSelect, {
            modelValue: charge.account,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => charge.account = $event),
            items: users.value,
            "item-title": "name",
            "item-value": "id",
            label: "Invoice User",
            placeholder: "Select User",
            info: "This user can be shown on the invoice, and also is the default for revenue allocation",
            clearable: "",
            "hide-details": true,
            "data-cy": "cbff-invoice-user-select"
          }, null, 8, ["modelValue", "items"])])) : _createCommentVNode("", true)]), showHourLimit.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(LlTextField, {
            modelValue: charge.limit.hours,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => charge.limit.hours = $event),
            type: "number",
            step: "any",
            min: 0,
            label: "Hour Limit",
            info: "The maximum number of hours that will be included in the fixed fee- the remaining will be billed hourly",
            disabled: charge.billed,
            "hide-details": true,
            "data-cy": "cbff-hour-limit-field"
          }, null, 8, ["modelValue", "disabled"])]), charge.limit && charge.limit.hours ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(LlTextField, {
            modelValue: charge.limit.rate.amount,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => charge.limit.rate.amount = $event),
            type: "number",
            rules: _unref(limitRateValidationRules),
            placeholder: "Required",
            label: "Limit Rate",
            info: "If the hourly limit is exceeded, the additional hours will be charged at the standard rate specified",
            disabled: charge.billed,
            "hide-details": true,
            "data-cy": "cbff-limit-rate-field"
          }, null, 8, ["modelValue", "rules", "disabled"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), showCodePicker.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(), _createBlock(CodePicker, {
            key: `code-picker-${charge.id || 'new'}`,
            form: charge,
            activityRequired: !!charge.matter?.client?.codes?.required?.activity,
            taskRequired: !!charge.matter?.client?.codes?.required?.task,
            onCodeChange: handleCodeChange,
            "data-cy": "cbff-code-picker"
          }, null, 8, ["form", "activityRequired", "taskRequired"]))])) : _createCommentVNode("", true), matterLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_v_skeleton_loader, {
            type: "article, actions",
            class: "mb-4"
          })])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_v_window_item, {
          value: "allocation",
          style: {
            "min-height": "700px"
          }
        }, {
          default: _withCtx(() => [_unref(features)?.fixedFeeAllocation ? (_openBlock(), _createBlock(RevenueAllocationTabV2, {
            key: 0,
            ref_key: "revenueAllocationTabRef",
            ref: revenueAllocationTabRef,
            "charge-id": charge.id || 'new',
            "fixed-fee-amount": Number(charge.amount) || 0,
            users: users.value,
            allocations: formData.allocations,
            "invoice-account": charge.account,
            state: props.state,
            "onUpdate:allocations": handleAllocationUpdate,
            "onUpdate:invoiceAccount": _cache[19] || (_cache[19] = $event => charge.account = $event),
            onValidationChanged: onAllocationValidationChanged
          }, null, 8, ["charge-id", "fixed-fee-amount", "users", "allocations", "invoice-account", "state"])) : (_openBlock(), _createBlock(RevenueAllocationTab, {
            key: 1,
            allocations: formData.allocations,
            "charge-amount": Number(charge.amount) || 0,
            users: users.value,
            "invoice-account": charge.account,
            "onUpdate:allocations": handleAllocationUpdate,
            "onUpdate:invoiceAccount": _cache[20] || (_cache[20] = $event => charge.account = $event),
            onValidationChanged: onAllocationValidationChanged
          }, null, 8, ["allocations", "charge-amount", "users", "invoice-account"]))]),
          _: 1
        }), _createVNode(QuickbookProductService, {
          "tab-value": 'quickbooks',
          "custom-style": {
            minHeight: '700px'
          },
          services: services.value,
          modelValue: selectedService.value,
          "onUpdate:modelValue": [_cache[21] || (_cache[21] = $event => selectedService.value = $event), productServiceChanged],
          description: "Select the QuickBooks Product/Service to which the fixed fee should map.",
          "additional-description": "This will map all the fixed fees that use this template to that Product/Service",
          "data-cy": "cbff-quickbooks-service"
        }, null, 8, ["services", "modelValue"]), _createVNode(_component_v_window_item, {
          value: "timeEntries"
        }, {
          default: _withCtx(() => [charge.id && !_unref(fixedFeeTemplate) && _unref(features)?.centralizedFixedFeePage ? (_openBlock(), _createBlock(FixedFeeTimeEntriesTab, {
            key: 0,
            ref_key: "timeEntriesTabRef",
            ref: timeEntriesTabRef,
            chargeId: charge.id,
            matterId: charge.matter?.id,
            state: props.state,
            stateParams: props.stateParams,
            rootScope: props.rootScope,
            alerts: props.alerts,
            snippetService: props.snippetService,
            entryEditService: props.entryEditService,
            tracking: props.tracking,
            clientMatterManager: props.clientMatterManager
          }, null, 8, ["chargeId", "matterId", "state", "stateParams", "rootScope", "alerts", "snippetService", "entryEditService", "tracking", "clientMatterManager"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]))], 544);
    };
  }
};